var _effectorFileName = "/builds/gmini/front-ui-kit/src/Button/Button.tsx";
import { PrimaryButton, SecondaryButton, TertiaryButton, WarningButton, LeftIcon, InfoButton } from './Button.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Button = ({
  onClick,
  children,
  active,
  disabled,
  size = 'small',
  leftIcon,
  rightIcon,
  buttonRef,
  seoEvent,
  ...other
}) => /*#__PURE__*/_jsxs(ButtonComp, {
  active: active,
  disabled: disabled,
  onClick: event => {
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
    seoEvent === null || seoEvent === void 0 ? void 0 : seoEvent();
  },
  size: size,
  withIcon: Boolean(leftIcon || rightIcon),
  buttonRef: buttonRef,
  ...other,
  children: [leftIcon && /*#__PURE__*/_jsx(LeftIcon, {
    size: size,
    children: leftIcon
  }), children, rightIcon]
});

const ButtonComp = ({
  color,
  buttonRef,
  ...other
}) => {
  switch (color) {
    case 'secondary':
      {
        return /*#__PURE__*/_jsx(SecondaryButton, { ...other,
          ref: buttonRef
        });
      }

    case 'tertiary':
      {
        return /*#__PURE__*/_jsx(TertiaryButton, { ...other,
          ref: buttonRef
        });
      }

    case 'warning':
      {
        return /*#__PURE__*/_jsx(WarningButton, { ...other,
          ref: buttonRef
        });
      }

    case 'info':
      {
        return /*#__PURE__*/_jsx(InfoButton, { ...other,
          ref: buttonRef
        });
      }

    default:
      {
        return /*#__PURE__*/_jsx(PrimaryButton, { ...other,
          ref: buttonRef
        });
      }
  }
};